import {
  analyticsCategory,
  overviewCategory,
  linksAndCreativesCategory,
  whiteLabelsCategory,
  payoutsCategory,
  referralProgramCategory,
  serviceCategory,
  ANALYTICS_CATEGORY_PATH,
  OVERVIEW_CATEGORY_PATH,
  LINKS_CATEGORY_PATH,
  PAYOUTS_CATEGORY_PATH,
  REFERRAL_PROGRAM_CATEGORY_PATH,
  SERVICE_CATEGORY_PATH,
  documentationCategory,
} from './common';

/** @deprecated */ export const ANALYTICS_LTV_PATH = `${ANALYTICS_CATEGORY_PATH}/ltv`;
export const ANALYTICS_LTV_STATISTICS_PATH = `${ANALYTICS_CATEGORY_PATH}/ltv-statistics`;
/** @deprecated */ export const ANALYTICS_TRAFFIC_ANALYZER_PATH = `${ANALYTICS_CATEGORY_PATH}/traffic-analyzer`;
export const ANALYTICS_TRAFFIC_QUALITY_PATH = `${ANALYTICS_CATEGORY_PATH}/traffic-quality`;
const managerAnalyticsCategory = analyticsCategory;

export const ANALYTICS_MB_REPORT_PATH = `${ANALYTICS_CATEGORY_PATH}/mb-report`;

/** @deprecated */ export const OVERVIEW_USERS_PATH = `${OVERVIEW_CATEGORY_PATH}/users`;
export const OVERVIEW_USER_ACCOUNTS_PATH = `${OVERVIEW_CATEGORY_PATH}/user-accounts`;
export const OVERVIEW_CPL_SETUP_PATH = `${OVERVIEW_CATEGORY_PATH}/cpl-setup`;
export const OVERVIEW_LTV_SETUP_PATH = `${OVERVIEW_CATEGORY_PATH}/ltv-setup`;
export const OVERVIEW_LTV_AFFILIATE_SETUP_PATH = `${OVERVIEW_CATEGORY_PATH}/ltv-affiliate-setup`;
export const OVERVIEW_CRM_PATH = `${OVERVIEW_CATEGORY_PATH}/crm`;
export const OVERVIEW_AFFILIATE_SURVEYS_PATH = `${OVERVIEW_CATEGORY_PATH}/affiliate-surveys`;
export const managerOverviewCategory = overviewCategory;

/** @deprecated */ export const LINKS_CREATIVES_BUILDER_PATH = `${LINKS_CATEGORY_PATH}/creatives-builder`;
export const LINKS_AD_CREATIVES_BUILDER_PATH = `${LINKS_CATEGORY_PATH}/ad-creatives-builder`;
export const LINKS_BANNERS_PATH = `${LINKS_CATEGORY_PATH}/banners`;
/** @deprecated */ export const LINKS_PRE_ROLLS_PATH = `${LINKS_CATEGORY_PATH}/pre-rolls`;
export const LINKS_PRE_ROLLS_ADS_PATH = `${LINKS_CATEGORY_PATH}/pre-rolls-ads`;
export const LINKS_PREFERRED_MODELS_PATH = `${LINKS_CATEGORY_PATH}/preferred-models`;
export const LINKS_GLOBAL_RULES_PATH = `${LINKS_CATEGORY_PATH}/global-rules`;
/** @deprecated */ export const LINKS_SMART_LINKS_PATH = `${LINKS_CATEGORY_PATH}/smart-links`;
export const LINKS_SMART_LINKS_GLOBAL_PATH = `${LINKS_CATEGORY_PATH}/smart-links-global`;
export const LINKS_SMART_LINKS_SEARCH_PATH = `${LINKS_CATEGORY_PATH}/smart-links-search`;
export const managerLinksAndCreativesCategory = linksAndCreativesCategory;

/** @deprecated */ export const PAYOUTS_BALANCE_PATH = `${PAYOUTS_CATEGORY_PATH}/balance`;
export const PAYOUTS_BALANCE_CONTROL_PATH = `${PAYOUTS_CATEGORY_PATH}/balance-control`;
export const PAYOUTS_MARK_AS_UNTRUSTED_PATH = `${PAYOUTS_CATEGORY_PATH}/mark-as-untrusted`;
/** @deprecated */ export const PAYOUTS_PAYOUTS_PATH = `${PAYOUTS_CATEGORY_PATH}/payouts`;
export const PAYOUTS_PAYOUTS_CONTROL_PATH = `${PAYOUTS_CATEGORY_PATH}/payouts-control`;
export const PAYOUTS_PENDING_USERS_PATH = `${PAYOUTS_CATEGORY_PATH}/pending-users`;
export const managerPayoutsCategory = payoutsCategory;

/** @deprecated */ export const REFERRAL_PROGRAM_INVITES_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/invites`;
/** @deprecated */ export const REFERRAL_PROGRAM_REFERRAL_INVITES_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/referral-invites`;
export const managerReferralProgramCategory = referralProgramCategory;

export const SERVICE_AUDIT_LOG_PATH = `${SERVICE_CATEGORY_PATH}/audit-log`;
export const managerServiceCategory = serviceCategory;

export default [
  managerAnalyticsCategory,
  managerOverviewCategory,
  managerLinksAndCreativesCategory,
  whiteLabelsCategory,
  managerPayoutsCategory,
  managerReferralProgramCategory,
  managerServiceCategory,
  documentationCategory,
];
